import { Company, isCompany, checkCompany } from "domain-entities";
import { CollectionPath } from "Configs/firebase";
import { useDocumentStore } from "Helpers/StoreHelper";
import { useRef } from "react";
import { firestore } from "firebase/app";

export function useCompanyStore(companyId?: string) {
  const collectionRef = useRef(
    firestore().collection(CollectionPath.COMPANIES)
  );

  return useDocumentStore<Company>({
    check: checkCompany,
    is: isCompany,
    collection: collectionRef.current,
    documentPath: companyId,
  });
}
